import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Logo from './Logo.svg';
import './Navbar.css';
import RefreshStatus from '../RefreshStatus/RefreshStatus';

export default class Navbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isTop: true,
      isMobileNavVisible: false,
    };
  }

  componentDidMount() {
    this.handleEvents();
    this.updateScrollPosition();
  }

  componentWillUnmount() {
    this.handleEvents(false);
  }

  handleEvents(isAttach = true) {
    ['scroll', 'resize'].forEach(event =>
      window[isAttach ? 'addEventListener' : 'removeEventListener'](event, this.updateScrollPosition.bind(this)));
  }

  updateScrollPosition() {
    const isTop = document.documentElement.scrollTop < 95;
    if (this.state.isTop !== isTop) {
      this.setState({ isTop });
    }
  }

  toggleNav(state) {
    const isMobileNavVisible = typeof state === 'boolean' ? state : !this.state.isMobileNavVisible;
    this.props.onToggle(isMobileNavVisible);
    this.setState({ isMobileNavVisible });
  }

  renderMenuItem(route) {
    if (!route.title && !route.icon) {
      return null;
    }

    return (
      <li role="presentation" key={route.path} onClick={() => this.toggleNav()}>
        <NavLink exact to={route.path} activeClassName="active">
          {route.title}
        </NavLink>
      </li>
    );
  }

  render() {
    const { isTop, isMobileNavVisible } = this.state;
    const {
      isLoading, error, lastLoadTime, routes,
    } = this.props;

    return (
      <div className="navbar-wrapper">
        {isMobileNavVisible ? (
          <div className="navbar-backdrop" onClick={() => this.toggleNav(false)} />
        ) : null}
        <nav className={`navbar navbar-default navbar-fixed-top ${!isTop && 'navbar--sticky'}`}>
          <div className="navbar-header">
            <a className="navbar-brand" href="/">
              <img alt="Rush Partners" src={Logo} />
            </a>

            <button type="button" onClick={() => this.toggleNav()} className="navbar-toggle is-mobile pull-right">
              <FontAwesomeIcon icon="bars" />
            </button>
          </div>

          <RefreshStatus
            className="navbar__refresh"
            isLoading={isLoading}
            error={error}
            lastLoadTime={lastLoadTime}
          />

          <ul className={`nav navbar-nav ${isMobileNavVisible && 'nav-visible'}`}>
            {routes.map(item => this.renderMenuItem(item))}

            <li role="presentation" onClick={() => this.toggleNav()}>
              <NavLink to="/auth" activeClassName="hide">
                <FontAwesomeIcon icon="sign-out-alt" />
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.js